import { CircleAlertIcon } from "lucide-react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/shared/components/ui/alert";
import { extractErrorMessage } from "../lib/extract-error-message";

type MatrixErrorAlertProps = {
  title: string;
  error: unknown;
  fallback: string;
};

// The page's one error surface: without it, mutations fail silently (no toast system).
export function MatrixErrorAlert({
  title,
  error,
  fallback,
}: MatrixErrorAlertProps) {
  return (
    <Alert variant="destructive">
      <CircleAlertIcon />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>
        {extractErrorMessage(error, fallback)}
      </AlertDescription>
    </Alert>
  );
}
